import { Box, Button, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { activeReasons, createBookingFormState, selectedDate, selectedTime, bookings, submitCaptureDetailsFormAsync, documentsStillRequired } from "../../features/BookingsSlice";
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import { getFormattedDate, getFormattedTime, getReasonDescriptionByPermutationID } from "../../features/Helper";
import { useEffect } from 'react';

const Confirmation = () => {
  const dispatch = useDispatch();
  const createBookingForm = useSelector(createBookingFormState);
  const selectedBookingDate = useSelector(selectedDate);
  const selectedBookingTime = useSelector(selectedTime);
  const reasons = useSelector(activeReasons);
  const allBookings = useSelector(bookings);
  const docsRequired = useSelector(documentsStillRequired);

  const getDisplayValue = (value: string | null): string => {
    if (!value || value === "") return "-";
    return value;
  }

  const displayObj = {
    Date: getFormattedDate(selectedBookingDate),
    Time: getFormattedTime(selectedBookingTime),
    "Booking Type": allBookings[allBookings.length - 1].BookingType,
    "Branch Name": allBookings[allBookings.length - 1].BranchName,
    Province: allBookings[allBookings.length - 1].Province,
    "Reason Category": allBookings[allBookings.length - 1].ReasonCategory,
  }

  useEffect(() => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }, []);

  return (
    <>
    <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", backgroundColor: "rgba(244, 251, 250, 1)", p: "32px" }}>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-start" }}>
        <EventAvailableIcon color="success" sx={{ fontSize: "36px", mr: "8px" }}/>
        <Typography sx={(theme) => ({ fontSize: theme.typography.h1, color: theme.palette.success.main })} role="heading" aria-level={3}>
          {docsRequired ? "Booking Awaiting Supporting Documents" : "Booking Confirmed!"}
        </Typography>
      </Box>
      {docsRequired ? <Typography sx={{ color: "#6A6A6A", fontSize: "14px", mt: "8px" }}>Please upload supporting documents to complete the booking</Typography> : null}
    </Box>

    {!docsRequired ? <Typography sx={(theme) => ({ fontSize: "18px", mt: "22px", color: theme.palette.grey[700] })}>
      Thank you for making a booking. We’ll see you soon!
    </Typography> : null}

    <Box sx={{ display: "flex", flexDirection: "column", border: "1px solid #E1E1E2", borderRadius: "8px", p: "32px", mt: "22px" }}>
      <Box sx={{ display: "flex", alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography sx={(theme) => ({ fontSize: theme.typography.h4, color: theme.palette.primary.main, fontWeight: "bold" })}>
          Booking Details
        </Typography>

        {!docsRequired ? <Typography sx={(theme) => ({ fontSize: theme.typography.h5, color: theme.palette.primary.main })}>CASE NO: {allBookings[allBookings.length - 1].CaseNo}</Typography> : null}
      </Box>

      <Box
        sx={{ display: "flex", justifyContent: "flex-start", mt: "22px", flexWrap: "wrap" }}
      >
        {Object.keys(displayObj).map((key: string) => {
          return (<Box
            key={key}
            sx={(theme) => ({
              display: "flex",
              flexDirection: "column",
              flex: "0 0 33%",
              [theme.breakpoints.down('md')]: {
                flex: '0 0 50%',
              },
              [theme.breakpoints.down('sm')]: {
                flex: '0 0 100%',
              },
              mt: "8px"
            })}
          >
            <Typography sx={(theme) => ({ fontSize: theme.typography.body1, mb: "2px" })}>
              <strong>{key}</strong>
            </Typography>
            <Typography sx={(theme) => ({ fontSize: theme.typography.h5, mb: "12px" })}>{(displayObj as any)[key]}</Typography>
          </Box>
        )})}

        <Box
          sx={(theme) => ({
            display: "flex",
            flexDirection: "column",
            flex: "0 0 66%",
            [theme.breakpoints.down('md')]: {
              flex: '0 0 100%',
            },
            mt: "8px"
          })}
        >
          <Typography sx={(theme) => ({ fontSize: theme.typography.body1, mb: "2px" })}>
            <strong>{getReasonDescriptionByPermutationID(reasons, Number(createBookingForm?.values.reason))}</strong>
          </Typography>
          <Typography sx={(theme) => ({ fontSize: theme.typography.h5, mb: "12px" })}>{getDisplayValue(createBookingForm?.values.reasonSummary)}</Typography>
        </Box>
      </Box>
    </Box>

    <Box
      sx={{
        mt: "22px",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        width: "100%",
      }}
    >
      <Button
        id="done"
        variant="contained"
        color="primary"
        onClick={() => {
          dispatch(submitCaptureDetailsFormAsync({confirmation: true}));
        }}
        sx={{ mb: "12px" }}
      >
        Done
      </Button>
    </Box>
    </>
  );
};

export default Confirmation;
